module.exports = __webpack_public_path__ + "static/media/mck_big.cab96c98.png";